// Subcategories for T-shits category
export const T_SHIRTS_SUBCATEGORIES_IDS = [
  16, 17, 399, 505, 104, 197, 247, 18, 198, 112, 354, 91, 714, 246, 460, 403,
  849, 19
];

// Number of units for default unit price test
export const DEFAULT_UNITS_TEST_NUMBER = 30;
